import React, { useEffect, useState } from "react";
import { FlagSvg } from "assets/images/common/svgs";
import useUsers from "containers/user-management/useHooks";
import { useSelector } from "react-redux";


interface Props {
  user: any;
}
const Wallet: React.FC<Props> = ({ user }) => {
  console.log(user, "100000000")
  const [activeTab, setActiveTab] = useState("Earned Points");

  const { getActivitiesEarnedPoints, getProductRequests } = useUsers();
  const { isLoading } = useSelector((state: any) => state.sharedReducer);
  const [earnPoints, setEarnPoints] = useState<any[]>([]);
  const [productRequests, setProductRequests] = useState<any[]>([]);

  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);

  const loadEarnPoints = async (page: number = 0) => {
    await getActivitiesEarnedPoints(
      setEarnPoints,
      {
        page,
        size: 5,
        ambassadorId: user?.user?.id,
      },
      page,
      setHasMore
    );
    setPage(page + 1);
  };

  useEffect(() => {
    loadEarnPoints(0);
  }, []);

  const handleLoadMore = () => {
    loadEarnPoints(page);
  };



  const loadProductRequests = async (page: number = 0) => {
    await getProductRequests(
      setProductRequests,
      {
        page,
        size: 5,
        ambassadorId: user?.user?.id,
      },
      page,
      setHasMore
    );
    setPage(page + 1);
  };

  useEffect(() => {
    loadProductRequests(0);
  }, []);

  const handleRequestLoadMore = () => {
    loadProductRequests(page);
  };

  return (
    <div>
      <div className="w-full sm:w-[300px] flex flex-col gap-3">
        <div className="flex flex-col gap-2">
          <span className="text-sm text-primaryText">
            Total
          </span>
          <span className="text-base font-bold text-primaryText">
            {user?.profiles?.ambassador?.totalEarnedPoints || 0} points
          </span>
        </div>
        <div className="flex gap justify-between">
          <span className="text-sm text-primaryText">
            Total Available Points
          </span>
          <span className="text-sm text-primaryText">{user?.profiles?.ambassador?.totalEarnedPoints || 0
            - user?.profiles?.ambassador?.totalSpentPoints || 0
          }</span>
        </div>
        <div className="flex gap justify-between">
          <span className="text-sm text-primaryText">Used points</span>
          <span className="text-sm text-primaryText">{user?.profiles?.ambassador?.totalSpentPoints || 0}</span>
        </div>
        {/* <div className="flex gap justify-between">
          <span className="text-sm text-primaryText">
            Pending points for Redeem
          </span>
          <span className="text-sm text-primaryText">9550</span>
        </div> */}
      </div>
      <div>
        <div className="flex gap-4 justify-start my-6">
          <button
            type="button"
            className={`px-4 py-2 text-xs font-bold transition-colors duration-300  ${activeTab === "Earned Points"
              ? "text-lightBlueColor border-b-2 border-lightBlueColor"
              : "text-mediumGrayText"
              }`}
            onClick={() => setActiveTab("Earned Points")}
          >
            Earned Points
          </button>
          <button
            type="button"
            className={`px-4 py-2 text-xs font-bold transition-colors duration-300  ${activeTab === "Used Points"
              ? "text-lightBlueColor border-b-2 border-lightBlueColor"
              : "text-mediumGrayText"
              }`}
            onClick={() => setActiveTab("Used Points")}
          >
            Used Points
          </button>
        </div>
        {activeTab === "Earned Points" && (
          <div className="flex flex-wrap items-center gap-6">
            {earnPoints.map((item, index) => (
              <div
                key={index + 1}
                className="border border-stokeLight rounded-[15px] p-6 flex flex-col items-center justify-center gap-2 text-center "
              >
                <div className="flex flex-col gap-1 items-center justify-center">
                  <span className="text-sm text-goldenAmberText font-bold">
                    {item?.pointsEarned} pts
                  </span>
                  <span className="text-sm font-bold text-primaryText">
                    {item?.activity}
                  </span>
                  <span className="text-xs text-primaryText">
                    {item?.createdAt
                      ? new Intl.DateTimeFormat("en-US", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      }).format(new Date(item?.createdAt))
                      : "-"}
                  </span>
                </div>
              </div>
            ))}
            {hasMore && (
              <div className="flex justify-center mt-4">
                <button
                  onClick={handleLoadMore}
                  className="px-4 py-2 text-sm font-semibold text-white bg-lightBlueColor rounded"
                >
                  See More
                </button>
              </div>
            )}
          </div>

        )}

        {activeTab === "Used Points" && (
          <div className="flex flex-wrap items-center gap-6">
            {productRequests.map((item, index) => (
              <div
                key={index + 1}
                className="border border-stokeLight rounded-[15px] p-6 flex flex-col items-center justify-center gap-2 text-center "
              >
                <div className="flex flex-col gap-1 items-center justify-center">

                  <span className="text-sm font-bold text-primaryText">
                    Notebook/Journal
                  </span>
                  <span className="text-xs text-primaryText">
                    {item?.createdAt
                      ? new Intl.DateTimeFormat("en-US", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      }).format(new Date(item?.createdAt))
                      : "-"}
                  </span>
                  <span className="text-sm text-goldenAmberText font-bold">
                    10 pts
                  </span>
                </div>
              </div>
            ))}
            {hasMore && (
              <div className="flex justify-center mt-4">
                <button
                  onClick={handleRequestLoadMore}
                  className="px-4 py-2 text-sm font-semibold text-white bg-lightBlueColor rounded"
                >
                  See More
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Wallet;
